import "./CommonValueOutput.scss";

import React from "react";

export const CommonValueOutput = ({
  label,
  value
} : any) =>
  <div className="share-info">
    <div className="item-label">{label}</div>
    <div className="item-value">{value}</div>
  </div>
;
